import { Component, OnInit, HostListener, ChangeDetectorRef, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LoaderGenericService } from '@app/@shared/loader-generic/loader-generic.service';
import { DetectDeviceService } from '@app/@shared/services/utils/detect-device.service';
import { CredentialsService } from '@app/login';
import { UserType } from '@app/@core/constants/user-credentials.constants';

import { DigitalSignatureCommonService } from '../digital-signature-service/digital-signature-common.service ';
import { DigitalSignatureServiceStore } from '../digital-signature-service/digital-signature-service.store';
import { environment } from '@env/environment';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

declare const validateLogaltyConsents: any;

@Component({
  selector: 'scf-consents',
  templateUrl: './logalty-consents.component.html',
  styleUrls: ['./logalty-consents.component.scss'],
  host: { '(window:consents.success)': 'onConsentsSuccess()', '(window:consents.error)': 'onConsentsError()' },
})
export class LogaltyConsentsComponent implements OnInit {
  @Output() finishConsent = new EventEmitter<any>();
  loadAPI: Promise<any>;
  isAsync: boolean = false;
  public isPrintOption: boolean;
  public sessionID: string;
  public sessionToken: String;
  public URL_CSS_TINGLE: SafeResourceUrl;
  public URL_CSS_CONSENT: SafeResourceUrl;
  public URL_CSS_CANDLE: SafeResourceUrl;

  constructor(
    private digitalSignatureServiceStore: DigitalSignatureServiceStore,
    private digitalSignatureCommonService: DigitalSignatureCommonService,
    private changeDetectorRef: ChangeDetectorRef,
    private loaderGenericService: LoaderGenericService,
    private router: Router,
    public route: ActivatedRoute,
    private detectDeviceService: DetectDeviceService,
    private credentialsService: CredentialsService,
    private sanitizer: DomSanitizer
  ) {
    this.URL_CSS_TINGLE = this.sanitizer.bypassSecurityTrustResourceUrl(
      environment.URL_LOGALTY_CONSENTS_CSS + environment.URL_LOGALTY_CSS_TINGLE
    );
    this.URL_CSS_CONSENT = this.sanitizer.bypassSecurityTrustResourceUrl(
      environment.URL_LOGALTY_CONSENTS_CSS + environment.URL_LOGALTY_CSS_CONSENT
    );
    this.URL_CSS_CANDLE = this.sanitizer.bypassSecurityTrustResourceUrl(
      environment.URL_LOGALTY_CONSENTS_CSS + environment.URL_LOGALTY_CSS_CANDLESTICK
    );
  }

  @HostListener('window:consents.success')
  onConsentsSuccess(): void {
    let result = 'success';
    this.digitalSignatureServiceStore.sendResultConsent(
      result,
      this.isPrintOption,
      this.detectDeviceService.isAccessByDevice()
    );
  }

  @HostListener('window:consents.error')
  onConsentsError(): void {
    let result = 'error';
    this.digitalSignatureServiceStore.sendResultConsent(
      result,
      this.isPrintOption,
      this.detectDeviceService.isAccessByDevice()
    );
  }

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.isPrintOption = params['isPrintOption'] === 'true' ? true : false;
    });
    console.log('consents isprintoption: ', this.isPrintOption);
    let data = this.digitalSignatureCommonService.SessionDataLogaltyObserver();

    if (data) {
      this.sessionID = data.sessionID;
      this.sessionToken = data.sessionToken;

      this.loadAPI = new Promise((resolve) => {
        this.loadScript();
        resolve(true);
      });

      this.loadAPI
        .then(() => {
          this.changeDetectorRef.detectChanges();
        })
        .finally(() => {
          this.loaderGenericService.showSpinner();
          setTimeout(() => {
            this.callConsenstLogalty();
          }, 1200);
        });
    } else {
      console.log('error al cargar consentimientos');

      let pageOpenSignature = JSON.parse(localStorage.getItem('pageOpenSignature'));
      this.router.navigate([pageOpenSignature.url, { keepFilter: true }]);
    }
  }

  public loadScript() {
    var isFound = false;
    var scripts = document.getElementsByTagName('script');

    for (var i = 0; i < scripts.length; ++i) {
      if (scripts[i].getAttribute('src') != null && scripts[i].getAttribute('src').includes('loader')) {
        isFound = true;
      }
    }

    if (!isFound) {
      var dynamicScripts = [
        environment.URL_LOGALTY_CONSENTS_JS + environment.URL_LOGALTY_JS_JQUERY,
        environment.URL_LOGALTY_CONSENTS_JS + environment.URL_LOGALTY_JS_TINGLE,
        environment.URL_LOGALTY_CONSENTS_JS + environment.URL_LOGALTY_JS_CONTEXT,
      ];
      for (var i = 0; i < dynamicScripts.length; i++) {
        let node = document.createElement('script');
        node.src = dynamicScripts[i];
        node.type = 'text/javascript';
        node.async = false;
        node.charset = 'utf-8';
        document.getElementsByTagName('head')[0].appendChild(node);
      }
    }
  }

  callConsenstLogalty() {
    validateLogaltyConsents();
    setTimeout(() => {
      this.loaderGenericService.stopSpinner();
    }, 1200);
  }
}
